import SchoolIcon from "@material-ui/icons/School";
import {
    VerticalTimeline,
    VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import StarIcon from "@material-ui/icons/Star";

const Education = () => {
    const items = [
        {
            cardTitle: "Széchenyi István University- Audi Hungaria Faculty of Automotive Engineering",
            cardSubtitle: "BSc - Vehicle Engineering",
            coursesHead: "Key Courses:",
            courses: [
                "Autonomous Vehicle Systems",
                "Vehicle Dynamics & Control",
                "Embedded Systems Programming",
                "Sensors & Perception",
                "Powertrain Engineering",
                "Mechatronics & Robotics",
                "Electric & Hybrid Vehicles",
                "Advanced CAD/CAE"
            ],
            cardDetailedText2: "GPA: 4.65/5.0 (Excellence)",
            date: "Sep,2022 - July,2025",
        },
        {
            cardTitle: "Al Balqa'a Applied University - Faculty Of Engineering & Technology",
            cardSubtitle: "BSc - Mechanical Engineering",
            coursesHead: "Key Courses:",
            courses: [
                "Dynamics of Machines",
                "Strength of Materials",
                "Power Plants",
                "Electrical Machines",
                "Engineering Maintenance & Safety",
                "Air Conditioning Technology",
                "Hydraulic & Pneumatic Technology",
                "Thermodynamics",
                "Heat Transfer",
                "Manufacturing Processes",
            ],
            cardDetailedText2: "GPA: 3.35/4.0",
            date: "2017 - 2021",
        },
        {
            cardTitle: "Luminus Technical University College-Abdul Aziz AL Ghurair  department(ASAC)",
            cardSubtitle: "Diploma in Software Development",
            date: "Jan,2022 - July,2022",
        },
    ];

    const timelineContentStyle = {
        background: "var(--card-bg)",
        borderRadius: "16px",
        border: "1px solid var(--border-color)",
        boxShadow: "0 20px 40px var(--shadow-color)",
        padding: "18px",
    };

    const timelineArrowStyle = {
        borderRight: "7px solid var(--card-bg)",
    };

    const iconStyle = {
        background: "var(--primary-color)",
        color: "#fff",
        boxShadow: "0 4px 12px var(--shadow-color)",
    };

    const titleStyle = {
        fontSize: "1.1em",
        color: "var(--text-color)",
        marginBottom: "8px",
        fontWeight: 600,
    };

    const subtitleStyle = {
        fontSize: "1em",
        fontWeight: 500,
        color: "var(--primary-color)",
        marginTop: "5px",
        marginBottom: "10px",
    };

    const helperTextStyle = {
        fontSize: "0.95em",
        fontWeight: 500,
        color: "var(--text-color-secondary)",
        marginTop: "15px",
        marginBottom: "10px",
    };

    const descriptionStyle = {
        fontSize: "0.95em",
        fontWeight: 400,
        color: "var(--text-color-secondary)",
        lineHeight: 1.7,
    };

    const highlightStyle = {
        fontSize: "1em",
        fontWeight: 600,
        color: "var(--primary-color)",
        marginTop: "15px",
        padding: "8px",
        backgroundColor: "rgba(5, 99, 187, 0.12)",
        borderRadius: "8px",
        textAlign: "center",
    };

    return (
        <section id="education" className="about background-alt">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <span className="section-index">08 — Education</span>
                    <h2>Mechanical foundations. Software depth. Vehicle systems.</h2>
                </div>

                <div className="row">
                    <div className="col-lg-12 d-flex justify-content-center">
                        <VerticalTimeline className="custom-line">
                            {items.map((data, i) => (
                                <VerticalTimelineElement
                                    key={i}
                                    className="vertical-timeline-element--work"
                                    contentStyle={timelineContentStyle}
                                    date={data.date}
                                    dateClassName="timeline-date"
                                    contentArrowStyle={timelineArrowStyle}
                                    iconStyle={iconStyle}
                                    icon={<SchoolIcon />}
                                >
                                    <div style={{ padding: "5px" }}>
                                        <h3
                                            className="vertical-timeline-element-title"
                                            style={titleStyle}
                                        >
                                            {data.cardTitle}
                                        </h3>
                                        <h4
                                            className="vertical-timeline-element-subtitle"
                                            style={subtitleStyle}
                                        >
                                            {data.cardSubtitle}
                                        </h4>
                                        {data.coursesHead && (
                                            <h5
                                                className="vertical-timeline-element-subtitle"
                                                style={helperTextStyle}
                                            >
                                                {data.coursesHead}
                                            </h5>
                                        )}
                                        {data.courses && (
                                            <ul className="education-courses">
                                                {data.courses.map((course) => (
                                                    <li key={course}>{course}</li>
                                                ))}
                                            </ul>
                                        )}
                                        {data.cardDetailedText && (
                                            <div className="education-description" style={descriptionStyle}>
                                                {data.cardDetailedText}
                                            </div>
                                        )}
                                        {data.cardDetailedText2 && (
                                            <div style={highlightStyle} className="education-highlight">
                                                {data.cardDetailedText2}
                                            </div>
                                        )}
                                    </div>
                                </VerticalTimelineElement>
                            ))}
                            <VerticalTimelineElement
                                iconStyle={iconStyle}
                                icon={<StarIcon />}
                            />
                        </VerticalTimeline>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Education;
